var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoidTxns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H7C5.89539 3 5 3.89539 5 5V19C5 20.1046 5.89539 21 7 21H17C18.1046 21 19 20.1046 19 19V7C17.438 5.43801 16.5622 4.56199 15 3ZM14.5 4.62141L17.3786 7.5H15C14.7244 7.5 14.5 7.27559 14.5 7V4.62141ZM17.5 19C17.5 19.2756 17.2758 19.5 17 19.5H7C6.72441 19.5 6.5 19.2756 6.5 19V5C6.5 4.72441 6.72441 4.5 7 4.5H13V7C13 8.10461 13.8954 9 15 9H17.5V19Z",
    fill: "#51566D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1823 11.5251L14.4754 10.8181L12.0004 13.2931L9.52535 10.8181L8.81836 11.5251L11.2934 14.0001L8.81836 16.4751L9.52535 17.1821L12.0004 14.7071L14.4754 17.1821L15.1823 16.4751L12.7073 14.0001L15.1823 11.5251Z",
    fill: "#51566D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoidTxns);
export default __webpack_public_path__ + "static/media/voidTxns.801e0dfab73823dda41d984944a15ce9.svg";
export { ForwardRef as ReactComponent };